// extracted by mini-css-extract-plugin
export default {"isDark":"Tooltip_isDark__Nmc5C"};